<app-attendee-chips-filter
  [buttonText]="'attendee.age_range.modal.title' | translate"
  (resetChipsFilter)="reset()"
  (updateChipsFilter)="update()"
  [hasSelectedFilters]="hasSelectedFilters"
  [isValidButtonDisabled]="ageForm.invalid"
>
  <div
    [formGroup]="ageRange"
    *ngFor="let ageRange of ageForm.controls; let i = index"
  >
    <app-form-checkbox
      formControlName="checked"
      [label]="ageRange.value.range.label | translate"
    ></app-form-checkbox>
  </div>
</app-attendee-chips-filter>
